import React, {useRef} from "react"
import {clearInputContent, toggleInputCloseButton} from "../../utils/utils"
import "./index.scss"

export default function TableHeaderSearch({handleSearch, placeholder, name, type}) {
  const inputRef = useRef(null)
  const handleOnChange = ({k, ref}) => {
    toggleInputCloseButton(ref)
    let v = ref.current.value
    handleSearch({k, v})
  }
  const handleClearInput = ({k, ref}) => {
    clearInputContent(ref)
    handleOnChange({k, ref})
  }

  return (
    <>
      <div
        className="input-wrapper table-header-search-input"
        data-testid="table-header-search-input"
      >
        <input
          className="table-header-input input-field-search input-field"
          placeholder={placeholder}
          name={name}
          type="text"
          style={type === "lgroup" ? {width: "80px"} : {width: "150px"}}
          aria-label="table-header-search"
          ref={inputRef}
          onChange={() => handleOnChange({k: name, ref: inputRef})}
        />
        <div
          data-testid="close-btn"
          onClick={() => handleClearInput({k: name, ref: inputRef})}
        ></div>
      </div>
    </>
  )
}
